var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_102",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 21V18H15V16H18V13H20V16H23V18H20V21H18ZM6 21V17H2V11C2 10.15 2.29167 9.4375 2.875 8.8625C3.45833 8.2875 4.16667 8 5 8H19C19.85 8 20.5625 8.2875 21.1375 8.8625C21.7125 9.4375 22 10.15 22 11V11.8C21.7 11.6333 21.3833 11.4875 21.05 11.3625C20.7167 11.2375 20.3667 11.15 20 11.1C20 10.8167 19.9042 10.5625 19.7125 10.3375C19.5208 10.1125 19.2833 10 19 10H5C4.71667 10 4.47917 10.0958 4.2875 10.2875C4.09583 10.4792 4 10.7167 4 11V15H6V13H14.55C14.2833 13.2833 14.05 13.5917 13.85 13.925C13.65 14.2583 13.4833 14.6167 13.35 15H8V19H13.35C13.4667 19.3667 13.6333 19.7167 13.85 20.05C14.0667 20.3833 14.3 20.7 14.55 21H6ZM16 8V5H8V8H6V3H18V8H16Z",
    fill: "#5434B6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/printIcon.2e22576d32be60938b0d330df89ed508.svg";
export { ForwardRef as ReactComponent };